export default __webpack_public_path__ + "static/media/Heart.1fd28fda.png";